import React from "react";
import * as common from "../../../../../const/Common/CommonFunc";
import Cookies from "js-cookie";
import axios from "../../../../../axios/axios_visitortag";
import apiConfig from "../../../../../axios/axios_api_services";
import './QRCheckin.scss';
import {Button as SementicBtn, Dropdown} from "semantic-ui-react";
import CovidResult from "../../../../Reception/History/CovidResult/CovidResult";
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import * as tableHeaders from "../../../../../const/table/TableHeaders";
import moment from "moment";
import {DatePicker, Icon, Spin} from "antd";
import Download from "../../../../../components/Button/DownloadbleButton/index";
import {MDBDataTable} from "mdbreact";
import * as actionCreator from "../../../../../store/Action";
import {connect} from "react-redux";
import $ from "jquery";
import * as DropDownConst from "../../../../../store/Reducer/DropDownConst";
import axiosTags from "../../../../../axios/axios_tag";
import * as keys from "../../../../../const/key/Key";
import * as healthConstants from "../../../../../const/health/Health";

const {RangePicker} = DatePicker;

function disabledDate(current) {
  return current && current > moment().endOf("day");
}

/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 10/28/20
 * Time: 6:03 PM
 */

class History extends React.Component {

  state = {
    status: "ALL",
    selectedColumn: "",
    searchDetails: "",
    visitors_list: [],
    isCovidDetails: false,
    startDate: '', endDate: '',corporateId: 0,
    covidObj: null, branches: [], branchId: '', isSpin: false, isBranchLoader: false
  };
  viewCovidDetails = (obj) => {
    this.props.setQRCovidResultViewer({
      guestQRIsCovidDetails: true,
      guestQRCovidObj: obj
    });
  };
  onChange = (date, dateString) => {
    if (dateString[0] === "" || dateString[1] === "") {

    } else {
      let start = new Date(dateString[0]);
      let end = new Date(dateString[1]);
      this.setState({startDate: start.getTime(), endDate: end.getTime()});
    }
  };

  changeSpinner = (type, condition) => {
    this.setState({[type]: condition})
  };

  getAllHistory(startDate, endDate, branchId) {
    if (!startDate) {
      startDate = this.state.startDate;
      endDate = this.state.endDate;
    }
    if (!branchId) branchId = this.state.branchId;

    this.changeSpinner("isSpin", true);
    const headers = {"Authorization": "Bearer " + Cookies.get(keys.ACCESS_TOKEN)};

    let coperateId = this.props.usr_obj.corporates[0].corporateId;
    // Get all history
    axios.get(apiConfig.CORPORATE_BRANCH_QR_CHECKIN_VISITORS_HISTORY({
      corporateId: coperateId,
      branchId: branchId,
      startDate: startDate,
      endDate: endDate
    }), {headers: headers})
      .then(async response => {
        let visitors = [];
        if (response.data.success) {
          let result = response.data.visitorList;
          if (result.length !== 0) {
            result.map((obj, index) => {
              let checkResult = obj.covidQuestionResponses.find(obj => obj.response);
              if (checkResult !== undefined && (checkResult.questionId === 3 || checkResult.questionId === 5 || checkResult.questionId === 6 ||
                checkResult.questionId === 7 || checkResult.questionId === 8)) {
                checkResult = undefined;
              }
              let object = {
                key: index + 1,
                status: obj.registrationStatus,
                checkedIn: obj.checkedIn,
                permission: checkResult === undefined ? "Granted" : "Rejected",
                // visitorIdentity: obj.visitorIdentity,
                visitorIdentity: obj.visitorTemporaryIdentity,
                visitorMobile: obj.visitorMobile,
                visitorName: obj.visitorName,
                address: `${obj.visitorAddress['line1'] ? obj.visitorAddress['line1'] : ""} ${obj.visitorAddress['line2'] ? obj.visitorAddress['line2'] : ""}`,
                city: obj.visitorAddress ? obj.visitorAddress['city'] : '',
                // district: obj.visitorAddress ? obj.visitorAddress['district'] : '',
                // visitingPurpose: obj.visitingPurpose ? obj.visitingPurpose : '',
                meetingVisitorId: obj.meetingVisitorId,
                covidQuestionResponses: obj.covidQuestionResponses
              };
              let incrementCount = 1;
              if (obj.covidQuestionResponses.length !== 0) {
                let selectedDynamicList = healthConstants.GUEST_FILTER_CORPORATE_COVID.find(obj => obj.corporateId === coperateId);
                obj.covidQuestionResponses.map((obj, index) => {
                  let condition = false;
                  if (selectedDynamicList && selectedDynamicList.selectedQuestions.length !== 0) {
                    selectedDynamicList.selectedQuestions.map((selectObj, index) => {
                      if (obj.questionId === selectObj) condition = true;
                    })
                  }
                  if (condition) {
                    object[`Question: ${incrementCount}`] = obj.response ? "YES" : "NO";
                    incrementCount++;
                  }
                })
              }
              object['isCovidForm'] = incrementCount !== 1;
              visitors.push(object);
            })
          }
        }
        this.setState({visitors_list: visitors});
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllHistory(startDate, endDate, branchId);
        }
      })
      .finally(fin => {
        this.changeSpinner("isSpin", false);
        this.setState({corporateId:coperateId})
      })
  };

  getAllBranches = (start, end) => {
    if (!start) {
      start = this.state.startDate;
      end = this.state.endDate;
    }

    this.changeSpinner("isBranchLoader", true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get(keys.ACCESS_TOKEN)
    };
    let coperateId = this.props.usr_obj.corporates[0].corporateId;
    axiosTags.get(apiConfig.CORPORATE_WITH_BRANCHES, {headers: headers})
      .then(response => {
        let branches = [];
        if (response.data.success) {
          let result = response.data.body;
          if (result.length !== 0) {
            result.map((resObj, index) => {
              if (resObj.corporateId === coperateId && resObj.branches.length !== 0) {
                branches.push({text: "ALL", value: 0, key: 0});
                resObj.branches.map((branch, index) => {
                  branches.push({
                    text: branch.name,
                    value: branch.branchId,
                    key: index
                  })

                });
              }
            });
          }
        }
        this.setState({branches, branchId: branches.length !== 0 ? 0 : ''});
        if (branches.length !== 0) this.getAllHistory(start, end, 0);
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.getAllBranches(start, end);
        }
      })
      .finally(fin => {
        this.changeSpinner("isBranchLoader", false);
      })
  };

  componentDidMount() {
    let start = new Date().setDate(new Date().getDate() - 7);
    let end = new Date().setDate(new Date().getDate());
    this.setState({startDate: start, endDate: end,});
    this.getAllBranches(start, end);

    this.fillData();
    $('#qr-checkin-branch-visitors-reports-table').bind('DOMSubtreeModified', this.fillData.bind(this));
  }

  fillData = () => {
    $("#qr-checkin-branch-visitors-reports-table > tbody > tr").each(function () {
      if ($(this).find('td').eq(3).text() === "Granted") {
        $(this).css("background-color", "rgb(215, 253, 234)")

      } else if ($(this).find('td').eq(3).text() === "Rejected") {
        $(this).css("background-color", "rgb(247, 223, 223)")
      } else {
        $(this).css("background-color", "white")
      }
    });
  };

  filterHandler = () => {
    let {branchId} = this.state;
    if (branchId === "") {
      common.notifyMessage("Please select branch");
      return;
    }
    this.getAllHistory();
  };

  render() {
    let {status, branches, branchId, isSpin, isBranchLoader} = this.state;

    let rows = [];
    let downloadList = [];

    this.state.visitors_list.map((obj, index) => {
      if ((status === obj.permission) || status === "ALL") {
        rows.push({
          key: obj.key,
          status: obj.status,
          checkedIn: obj.checkedIn,
          permission: obj.permission,
          visitorIdentity: obj.visitorIdentity,
          visitorMobile: obj.visitorMobile,
          visitorName: obj.visitorName,
          address: obj.address,
          city: obj.city,
          // district: obj.district,
          // visitingPurpose: obj.visitingPurpose,
          meetingVisitorId: obj.meetingVisitorId,
          covid: obj.isCovidForm ? <SementicBtn className={"covid-tbl-btn"} onClick={() => this.viewCovidDetails(obj)}>View</SementicBtn>:null,
        });
        downloadList.push({...obj});
      }
    });

    let data = {columns: tableHeaders.qrCheckInColumns, rows};
    return (

      <div className={"qr-checkin-branch"}>
        {
          this.props.usr_obj.userRoles === "RECEPTION" ?
            <h4 className={"route-name-style"}>{this.props.route_name}</h4>
            : <h4 className={"route-none-style"}/>
        }

        <CovidResult obj={this.state.covidObj} corporateId={this.state.corporateId} closeModal={() => this.setState({isCovidDetails: false})}/>

        <Row>
          <Col xs="12" sm="12" md="12" lg="12" xl="12">
            <Card>
              <CardHeader>
                Filter Options
                <div className={"align-right filter-btn"}>
                  <SementicBtn onClick={this.filterHandler} circular icon='refresh'/>
                </div>
              </CardHeader>
              <CardBody className=" paddingBottom">
                <div className="form-group paddingBottom">
                  <Row>
                    <Col md={4}>
                      <label className={"mt-2"}>Date Range</label>
                      <br/>

                      <RangePicker
                        size={"mini"}
                        defaultValue={[moment().subtract(7, "days"), moment().subtract(0, "days")]}
                        disabledDate={disabledDate}
                        format="YYYY-MM-DD"
                        onChange={this.onChange}
                      />
                    </Col>
                    {/*<Col md={2}>*/}
                    {/*<label className={"mt-2"}>Status</label>*/}
                    {/**/}
                    {/*</Col>*/}
                    <Col md={3}>
                      <label className={"mt-2"}>Branches</label>
                      <Dropdown
                        loading={isBranchLoader}
                        fluid selection
                        options={branches} value={branchId}
                        placeholder={"Select branch"}
                        onChange={(event, {value}) => {
                          this.setState({branchId: value})
                        }}
                      />
                    </Col>
                    <Col lg={2}>
                      <label className={"mt-2 none-opacity"}>Search</label>
                      <br/>
                      <SementicBtn className={"yellow-btn"} disabled={isBranchLoader} positive onClick={this.filterHandler}>Search</SementicBtn>
                    </Col>
                  </Row>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col lg="12">
            <Card className="card margin0">
              <CardHeader>
                Visitors History
                <div className={"status-wrapper"}>
                  <Dropdown
                    fluid selection
                    options={DropDownConst.qrCheckinBranchStatus} value={status}
                    onChange={(event, {value}) => {
                      this.setState({status: value})
                    }}
                  />
                </div>
                <Download data={downloadList} userType={"QR_CHECK_IN_BRANCH"}/>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col lg="12">
                    <Spin spinning={isSpin} delay={10}
                          indicator={<Icon type="loading" style={{fontSize: 24}} spin/>}>
                      <MDBDataTable
                        id={"qr-checkin-branch-visitors-reports-table"}
                        exportToCSV={true}
                        searching={true}
                        searchLabel={"Search visitor"}
                        responsive
                        responsiveSm
                        responsiveMd
                        responsiveLg
                        responsiveXl
                        bordered
                        hover
                        data={data}/>
                    </Spin>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  visitors: state.viewAllCheckIN.visitors,
  checkInVisitors: state.viewAllCheckIN.checkInVisitors,
  historyColumns: state.viewAllCheckIN.historyColumns,
  column: state.viewAllCheckIN.column,

  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    // view covid result
    setQRCovidResultViewer: (data) => dispatch(actionCreator.setQRCovidResultViewer(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(History);
